import { Component } from "react";

export const BoasVindas =	
	class extends Component {
		render() {
			return (
				<div className="d-flex justify-content-center" style={{margin: "10px"}}>
					<h2>Bem-vindo à Plataforma de Interoperabilidade - Conecta GOV.BR</h2>
				</div>
			);
		}
	}
		